import { render, staticRenderFns } from "./CountSecondPromocao.vue?vue&type=template&id=ff526554&scoped=true&"
import script from "./CountSecondPromocao.vue?vue&type=script&lang=js&"
export * from "./CountSecondPromocao.vue?vue&type=script&lang=js&"
import style0 from "./CountSecondPromocao.vue?vue&type=style&index=0&id=ff526554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff526554",
  null
  
)

export default component.exports